import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// From altide-siem-frontend's src/lib/cn.ts, with one fix that should go back
// upstream: SIEM's copy registers text-2xs/3xs/4xs, which its own type ramp
// has since removed, and not the ramp that replaced them. tailwind-merge then
// reads `text-dense` as a text COLOUR, so cn("text-dense", "text-red-500")
// silently drops the size. Registering the real ramp (index.css's @theme
// inline --text-* keys, from config.css's --type-*) makes size and colour
// merge independently, and makes text-dense vs text-sm resolve to the last.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["label", "micro", "dense", "body", "body-lg", "heading-sm", "heading", "heading-lg", "display"] },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
